





















































































































import { Component, Vue } from 'vue-property-decorator';
import AppList from '@/components/AppList.vue';
import AppLoading from '@/components/AppLoading.vue';
import { Action } from 'vuex-class';
import { ProductReport } from '@/interfaces/ProductReport';
import { TJsonApiBody } from 'jsona/lib/JsonaTypes';
import {eventBus, eventBusEvents} from "@/helpers/eventBusHelper";

@Component({
    name: 'ShoppingCart',
    components: {
        appList: AppList,
        appLoading: AppLoading,
    },
})
export default class ShoppingCart extends Vue {
    public $refs!: {
        productReportList: AppList;
        topWrapper: HTMLDivElement;
    };

    @Action('user/getShoppingCartRecords')
    protected getShoppingCartRecords!: () => void;
    @Action('user/removeShoppingCartRecords')
    protected removeShoppingCartRecords!: (idsToBeRemoved: number[]) => void;
    @Action('user/revertToShoppingList') protected revertToShoppingList!: (
        idsToBeReverted: number[],
    ) => Promise<unknown>;
    @Action('user/getBillingAddresses')
    protected getBillingAddresses!: () => void;

    protected checkAll = false;
    protected activeIndices: number[] = [];
    protected keywords = '';
    protected dialogVisible = false;
    protected duplicates: number[] = [];
    protected isButtonEnabled = true;
    protected pendingFunds = {
        subscriptions: 'buySubscription',
        credits: 'buyPrepaidCredit',
        'pay as you go': 'usePayPerView',
    };

    private isIndeterminate = false;
    private isLoading = false;
    private observer: IntersectionObserver | null = null;

    @Action('user/getCartSummary') private getCartSummary!: (
        payload: CartSummaryRequest,
    ) => Promise<TJsonApiBody | string>;

    protected async mounted() {
        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getShoppingCartRecords();
        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);

        await this.getBillingAddresses();
        const activeCheckoutMethod = this.activeCheckoutMethod;
        // @ts-ignore
        const payMethod = this.pendingFunds[activeCheckoutMethod];
        if (payMethod === 'usePayPerView') {
            if (this.billingAddresses.length > 0) {
                this.getCartSummary({
                    type: payMethod,
                    billingAddressId: this.billingAddresses[0].id,
                });
            } else {
                this.getCartSummary({
                    type: payMethod,
                });
            }
        }

        this.observer = new IntersectionObserver(
            ([e]) =>
                e.target.classList.toggle('is-sticky', e.intersectionRatio < 1),
            { threshold: [1] },
        );

        this.observer.observe(this.$refs.topWrapper);
    }

    protected destroyed() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }

    protected get shoppingCartRecords() {
        return this.$store.getters['user/shoppingCartRecords'];
    }

    protected get shoppingListRecords() {
        return this.$store.getters['user/shoppingListRecords'];
    }

    protected get cartSummary() {
        return this.$store.getters['user/cartSummary'];
    }

    protected get activeCheckoutMethod() {
        return this.$store.getters['user/activeCheckoutMethod'];
    }

    protected get billingAddresses() {
        return this.$store.getters['user/billingAddresses'];
    }

    protected handleCheckAllChange(val: boolean) {
        this.$refs.productReportList.toggleAllIndices(val);
        this.isIndeterminate = false;
    }

    protected async onRevertToShoppingList() {
        if (!this.isButtonEnabled) {
            return;
        }
        this.duplicates = [];
        const items: number[] = [];
        this.isButtonEnabled = false;
        const listItemIds = this.$store.getters['user/shoppingListRecords'].map(
            (item: ProductReport) => item.brand,
        );
        for (const activeIndice of this.activeIndices) {
            const index = this.shoppingCartRecords.findIndex(
                (element: any) => element.id === activeIndice,
            );
            const brandId = this.shoppingCartRecords[index].brand.importId;
            if (
                listItemIds.find(
                    (element: ProductReport) => element.importId === brandId,
                )
            ) {
                this.duplicates.push(Number(brandId));
            } else {
                items.push(activeIndice);
            }
        }
        if (this.duplicates.length) {
            this.dialogVisible = true;
        }
        await this.revertToShoppingList(items);
        if (this.$refs.productReportList) {
            this.$refs.productReportList.toggleAllIndices(false);
        }
        this.isButtonEnabled = true;
        this.$message({
            message: 'Reverted to shopping list',
            type: 'success',
        });
    }

    protected onCheckoutAll() {
        if (!this.isButtonEnabled) {
            return;
        }
        this.isButtonEnabled = false;
        this.$refs.productReportList.toggleAllIndices(false);
        this.$router.push({ name: 'Payment' });
        this.isButtonEnabled = true;
    }

    protected async removeSelected() {
        if (!this.isButtonEnabled) {
            return;
        }
        this.isButtonEnabled = false;
        await this.removeShoppingCartRecords(this.activeIndices);

        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getShoppingCartRecords();
        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);

        this.$refs.productReportList.toggleAllIndices(false);
        this.isButtonEnabled = true;
    }

    protected onActiveIndicesChange(indices: number[]) {
        this.activeIndices = indices;
        if (this.activeIndices.length <= 0) {
            this.checkAll = false;
        } else if (
            this.activeIndices.length > 0 &&
            this.activeIndices.length === this.shoppingCartRecords.length
        ) {
            this.checkAll = true;
        }
        this.isIndeterminate =
            this.activeIndices.length >= 1 &&
            this.activeIndices.length !== this.shoppingCartRecords.length;
    }

    protected onValueChange(value: boolean) {
        this.isIndeterminate = value;
    }

    protected onLoadingToggle(value: boolean) {
        this.isLoading = value;
        if (!value) {
            this.handleCheckAllChange(false);
        }
    }

    protected async onRemoveSingle(id: number[]) {
        await this.removeShoppingCartRecords(id);

        eventBus.$emit(eventBusEvents.activateGlobalLoading);
        await this.getShoppingCartRecords();
        eventBus.$emit(eventBusEvents.deactivateGlobalLoading);
    }
}
